import React, { useState } from 'react';
import { Badge, Button, Card, Icon, Link, Modal } from '@shopify/polaris';
import { LockMinor, ViewMinor, HideMinor } from '@shopify/polaris-icons';

const CareerPortalRow = ({ id, title, subtitle, isLocked, isActive, onEdit, isFreemium, onToggleActive, changeRoute }) => {
  const [isConfirmPublishModalOpen, setIsConfirmPublishModalOpen] = useState(false);
  const toggleConfirmPublishModal = () => setIsConfirmPublishModalOpen(!isConfirmPublishModalOpen);
  return (
    <Card.Section>
      <div className='career-portal__row-grid'>
        <div>
          {isLocked && (
            <span className='career-portal__row-lock-icon'>
              <Icon source={LockMinor} />
            </span>
          )}
          <h2 className='Polaris-TextStyle--variationStrong'>{title}</h2>
          <span>{subtitle}</span>
          {isLocked && (
            <Link onClick={() => changeRoute('/account-plan')} removeUnderline>
              Upgrade account plan
            </Link>
          )}
        </div>
        <div className='justify-self'>
          <Badge status={isActive && !isLocked ? 'success' : ''}>
            <span className='capitalize'>{isActive && !isLocked ? 'Active' : 'Inactive'}</span>
          </Badge>
        </div>
        {/*<div className='career-portal__row-eye-container'>
          {!isFreemium && !!onToggleActive && (
            <div className='career-portal__row-eye-button' onClick={toggleConfirmPublishModal}>
              <span className='career-portal__row-eye'>
                <Icon source={isActive ? HideMinor : ViewMinor} color='inkLighter' accessibilityLabel='Visible icon' />
              </span>
              <p>{`${isActive ? 'Hide' : 'Publish'} section`}</p>
            </div>
          )}
        </div>*/}
        <div>
          <Button
            disabled={isLocked}
            fullWidth
            onClick={onEdit}
            connectedDisclosure={
              !isFreemium
                ? {
                    accessibilityLabel: 'Career portal section status',
                    actions: [
                      {
                        content: isActive ? 'Unpublish' : 'Publish',
                        onAction: toggleConfirmPublishModal,
                        disabled: !onToggleActive,
                      },
                    ],
                  }
                : undefined
            }>
            Edit
          </Button>
        </div>
      </div>
      <Modal
        open={isConfirmPublishModalOpen}
        onClose={toggleConfirmPublishModal}
        title={`${isActive ? 'Hide' : 'Publish'} section`}
        primaryAction={{
          content: `Yes, ${isActive ? 'hide' : 'publish'} section`,
          onAction: () => {
            onToggleActive(id);
            toggleConfirmPublishModal();
          },
        }}
        secondaryActions={[
          {
            content: 'Cancel',
            onAction: toggleConfirmPublishModal,
          },
        ]}
        loading={false}>
        <Modal.Section>
          <p>{`Do you want to ${isActive ? 'hide' : 'publish'} this section to your career portal page?`}</p>
        </Modal.Section>
      </Modal>
    </Card.Section>
  );
};

export default CareerPortalRow;
